import { Offcanvas } from 'react-bootstrap';
import { recordItemEvent } from '../api';

// Bottom sheet on mobile / edge panel on larger screens (Offcanvas's default behavior), listing
// Call / WhatsApp / Send Enquiry for one item - user story 4.1. Every action records a "contact"
// engagement event (story 4.2 keeps the full routing/logging on the backend side; this is the UI
// half firing the signal).
export default function ContactOwnerSheet({ item, show, onHide }) {
  if (!item) return null;

  const phone = item.attributes?.ownerPhone || item.attributes?.phone;
  const storeName = item.attributes?.storeName || 'the owner';

  const track = () => recordItemEvent(item._id, 'contact');

  const handleCall = () => {
    track();
    if (phone) window.location.href = `tel:${phone}`;
  };

  const handleWhatsApp = () => {
    track();
    const digits = (phone || '').replace(/[^\d]/g, '');
    const message = encodeURIComponent(`Hi, I'm interested in "${item.name}" (₹${item.price}/${item.priceUnit}) on RentalVerse.`);
    window.open(digits ? `https://wa.me/${digits}?text=${message}` : `https://wa.me/?text=${message}`, '_blank', 'noopener');
  };

  const handleEnquiry = () => {
    track();
    const subject = encodeURIComponent(`Enquiry: ${item.name}`);
    const body = encodeURIComponent(`Hi ${storeName},\n\nI'd like to know more about "${item.name}" (₹${item.price}/${item.priceUnit}).\n\n`);
    window.location.href = `mailto:?subject=${subject}&body=${body}`;
  };

  return (
    <Offcanvas show={show} onHide={onHide} placement="bottom" className="contact-owner-sheet">
      <Offcanvas.Header closeButton>
        <Offcanvas.Title as="div">
          <div className="fw-semibold">{item.name}</div>
          <div className="text-muted small">
            ₹{item.price}/{item.priceUnit} &middot; {storeName}
          </div>
        </Offcanvas.Title>
      </Offcanvas.Header>
      <Offcanvas.Body className="d-flex flex-column gap-2 pb-4">
        <button type="button" className="btn btn-outline-dark text-start" onClick={handleCall} disabled={!phone}>
          📞 Call Owner {!phone && <span className="text-muted">(number unavailable)</span>}
        </button>
        <button type="button" className="btn btn-outline-success text-start" onClick={handleWhatsApp}>
          💬 WhatsApp
        </button>
        <button type="button" className="btn btn-outline-primary text-start" onClick={handleEnquiry}>
          ✉ Send Enquiry
        </button>
      </Offcanvas.Body>
    </Offcanvas>
  );
}
